import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { warn } from "../utils/logging/logging";
import { selectOutskirtBuildingInfo } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectExternalBarnInfo = function (state) {
    warn("External Barn not implemented!");
};
export var selectExternalBarnCurrentStorage = function (state) {
    var outskirtInfo = selectOutskirtBuildingInfo(state, IdOutskirtBuildings.ExternalBarn);
    if (outskirtInfo.proto == undefined) {
        return 0;
    }
    var level = outskirtInfo.proto.stage || 1;
    var stage = outskirtInfo.balancing.outsideBuildingStage[level - 1];
    return stage.storageCapacity || 0;
};
export var selectIsQualifiedForExternalBarn = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.ExternalBarn);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectExternalBarnInfo.ts
// module id = 820
// module chunks = 3